<template>
  <div class="card">
    <div class="faq-nav">
      <div v-for="item in faqNav()" :key="item.value" class="faq-nav__row">

        <a-collapse v-if="item.children" :bordered="false" class="faq-nav__collapse">
          <a-collapse-panel
              :key="item.value"
              :header="item.label"
              class="faq-nav__panel"
          >
            <div
                v-for="child in item.children"
                :key="child.anchor"
                class="faq-nav__child"
                :class="{ 'is-active': activeAnchor === child.anchor }"
                @click.prevent="onChildClick(item.value, child.anchor)"
            >
              {{ child.label }}
            </div>
          </a-collapse-panel>
        </a-collapse>

        <div
            v-else
            class="faq-nav__item"
            :class="{ 'is-active': selected === item.value }"
            @click.prevent="selectBlock(item.value)"
        >
          {{ item.label }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {faqNav} from "@/mixins/faqNav";
import {computed} from "@vue/reactivity";
import {ref} from "@vue/runtime-core";
import {nextTick} from "vue";
export default {
  methods: {
    faqNav() {
      return faqNav
    }
  },
  props: {
    modelValue: {
      type: String,
      default: "mainBlock",
    },
  },
  emits: ["update:modelValue", "change"],
  setup(props, context) {
    const selected = computed(() => props.modelValue);
    const activeAnchor = ref(null);

    const selectBlock = (value) => {
      context.emit("update:modelValue", value);
      context.emit("change", value);
      activeAnchor.value = null;
    };

    const scrollToAnchor = (anchorId) => {
      const el = document.getElementById(anchorId);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const onChildClick = async (blockKey, anchorId) => {
      if (blockKey && blockKey !== props.modelValue) {
        selectBlock(blockKey);
      }

      activeAnchor.value = anchorId;

      await nextTick();
      window.setTimeout(() => scrollToAnchor(anchorId), 100);
    };

    return {
      selected,
      selectBlock,
      scrollToAnchor,
      activeAnchor,
      onChildClick
    };
  }
}
</script>

<style scoped>
.faq-nav {
  display: block;
}

.faq-nav__item {
  display: block;
  padding: 10px 12px;
  color: var(--main-font);
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  border-radius: 8px;
  cursor: pointer;
}

.faq-nav__item.is-active {
  background: #f2f2f2;
  font-weight: 600;
}

.faq-nav__collapse :deep(.ant-collapse) {
  border: 0;
  background: transparent;
}

.faq-nav__collapse :deep(.ant-collapse-item) {
  border: 0;
  background: #FFFFFF;
  font-family: "Open Sans", sans-serif;
}

.faq-nav__collapse :deep(.ant-collapse-header) {
  padding: 10px 12px !important;
  background: transparent !important;
  color: var(--main-font) !important;
  font-size: 14px !important;
  line-height: 20px !important;

  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.faq-nav__collapse :deep(.ant-collapse-header) {
  padding-inline-start: 12px !important;
  font-family: "Open Sans", sans-serif;
}

.faq-nav__collapse :deep(.ant-collapse-header-text) {
  flex: 1 1 auto !important;
}

.faq-nav__collapse :deep(.ant-collapse-expand-icon) {
  order: 2 !important;
  margin-inline-start: auto !important;
  margin-inline-end: 0 !important;
  color: var(--main-font) !important;
  font-size: 12px;
}

.faq-nav__collapse :deep(.ant-collapse-header .ant-collapse-expand-icon) {
  padding: 0 !important;
}

.faq-nav__collapse :deep(.ant-collapse-item-active > .ant-collapse-header) {
  background: transparent !important;
}

.faq-nav__collapse :deep(.ant-collapse-header:hover) {
  background: #f7f7f7 !important;
  border-radius: 8px;
}

.faq-nav__collapse :deep(.ant-collapse-content),
.faq-nav__collapse :deep(.ant-collapse-content-box) {
  background: transparent !important;
  border: 0 !important;
  padding: 0 !important;
}

.faq-nav__children {
  padding: 4px 0 10px 12px;
}

.faq-nav__child {
  display: block;
  padding: 8px 12px 8px 22px;
  color: var(--grey-text);
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
}

.faq-nav__child.is-active {
  background: #f2f2f2;
  border-radius: 8px;
  color: var(--main-font);
  font-weight: 600;
}

.faq-nav__item:hover {
  background: #f7f7f7;
}

.faq-nav__child:hover {
  color: #595959;
}
</style>